import { WorkspaceRole } from "@web-app/types";
import http from "@web-app/utils/http";

const base_url = "/workspaceRoles";

export const list = async () => {
  return http.get<WorkspaceRole[]>(base_url).then((response) => response.data);
};
